import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fleetApi } from '../../services/fleetApi';

// The fleet the fleet-manager nav should point at: the one in the URL, else
// the user's first fleet. Shares FleetHome's ['fleets'] cache, so this costs
// no extra request once the fleet list has loaded.
export function useCurrentFleetId(enabled) {
  const { pathname } = useLocation();
  const fromUrl = pathname.match(/^\/fleet\/(\d+)/)?.[1] || null;

  const { data } = useQuery({
    queryKey: ['fleets'],
    queryFn: async () => {
      try {
        return (await fleetApi.listFleets()) || { fleets: [], total: 0 };
      } catch {
        return { fleets: [], total: 0 };
      }
    },
    enabled: enabled && !fromUrl,
    staleTime: 60_000,
  });

  return fromUrl || data?.fleets?.[0]?.id || null;
}
